import { createSignal, onMount } from "solid-js";

import styles from "~/components/Post.module.scss";

export default function LyricsTable(props: any) {
  const [tableRef, setTableRef] = createSignal<HTMLTableElement>();

  function showHideLyrics(index: number, focus = true) {
    const table = tableRef();

    for (const cell of table?.querySelectorAll<HTMLElement>("td, th") ?? []) {
      if (!cell.matches(":last-child")) {
        const toggle = cell.matches(`:nth-child(${index.toString()})`);
        cell.style.display = toggle ? "" : "none";
      }
    }

    if (focus) {
      table
        ?.querySelector<HTMLButtonElement>(
          `th:nth-child(${index.toString()}) [data-col='${index.toString()}']`,
        )
        ?.focus();
    }
  }

  onMount(() => {
    const table = tableRef();
    const alts = table?.querySelectorAll<HTMLSpanElement>("thead span") ?? [];

    if (alts.length === 0) {
      return;
    }

    const names = [...alts].map((alt) => alt.textContent ?? "");

    for (const alt of alts) {
      alt.insertAdjacentHTML(
        "afterend",
        names
          .map((name, index) => {
            const isActive = name === alt.textContent;
            return `<button type="button" class="${styles.link}" aria-pressed="${isActive.toString()}" data-col="${(index + 1).toString()}" href="#">${name}</button>`;
          })
          .join(" | "),
      );
      alt.hidden = true;
    }

    table?.addEventListener("click", (event) => {
      const target = (event.target as HTMLElement).closest<HTMLElement>(
        "thead button",
      );

      if (!target) {
        return;
      }

      event.preventDefault();
      showHideLyrics(Number.parseInt(target.dataset.col ?? "0", 10));
    });

    showHideLyrics(alts.length, false);
  });

  return <table ref={setTableRef} {...props} />;
}
